const labels = { not_reported: 'Not reported', not_applicable: 'Not applicable', needs_review: 'Needs review' };
export function missingFieldLabel(record, field, fallback = 'Not reported') {
  return labels[record?.field_status?.[field]] || fallback;
}
export function intervalMissingLabel(record) {
  const labels = ['ci_lower', 'ci_upper'].filter(field => record[field] == null || record[field] === '')
    .map(field => missingFieldLabel(record, field));
  return labels.includes('Needs review') ? 'Needs review' : labels.length && labels.every(value => value === 'Not applicable') ? 'Not applicable' : 'Not reported';
}
